import CryptoJS from "crypto-js";

const Base64 = (message: any, mode: "encode" | "decode") => {
  if (!message) {
    return;
  }

  if (mode === "encode") {
    message = CryptoJS.enc.Utf8.parse(message);
    return CryptoJS.enc.Base64.stringify(message).replace("=", "");
  } else {
    message = CryptoJS.enc.Base64.parse(message);
    return CryptoJS.enc.Latin1.stringify(message);
  }
};

export const encode = (message: string) => {
  return Base64(message, "encode");
};

export const decode = (message: string) => {
  return Base64(message, "decode");
};
